import React, { useState } from 'react';
import { supabase } from './lib/supabase';

const C = {
  bg:'#07111f',
  bg2:'#0d1c31',
  panel:'rgba(13, 22, 37, 0.92)',
  panelSoft:'rgba(18, 29, 46, 0.82)',
  panelBorder:'rgba(148, 163, 184, 0.16)',
  white:'#ffffff',
  ink:'#f8fafc',
  inkSoft:'#d6e0f0',
  copy:'#a7b6cd',
  blue:'#5aa2ff',
  blue2:'#1f78ff',
  blueL:'rgba(90, 162, 255, 0.14)',
  blueB:'rgba(90, 162, 255, 0.26)',
  gold:'#f4d089',
  goldSoft:'rgba(244, 208, 137, 0.16)',
  grey:'#7f8ea7',
  grey2:'#8ea1bd',
  grey4:'rgba(148, 163, 184, 0.08)',
  green:'#22c55e',
  red:'#ef4444',
  border:'rgba(148, 163, 184, 0.16)',
  med:'#d9e4f5',
};

const CONTENT_TYPES = [
  {id:'sa_original',icon:'🎭',label:'SA Original Series',desc:'Drama, reality, lifestyle, comedy — long form episodes'},
  {id:'sports',icon:'⚽',label:'Sports Content',desc:'Live watch-alongs, pre/post match analysis, PSL, Springboks'},
  {id:'talk_show',icon:'🎙️',label:'Talk Show',desc:'Panel discussions, interviews, current affairs'},
  {id:'podcast',icon:'🎧',label:'Video Podcast',desc:'Episode-based video podcast series'},
];

const BENEFITS = [
  {icon:'💰',label:'75% founding creator revenue share',desc:'For your first 12 months on the platform'},
  {icon:'🚀',label:'Priority launch consideration',desc:'Founding creators are reviewed ahead of the wider creator rollout'},
  {icon:'🛠️',label:'Onboarding support',desc:'We help approved creators get channel-ready before launch'},
  {icon:'🇿🇦',label:'Built for South African audiences',desc:'A local platform focused on local stories, sports and culture'},
  {icon:'📬',label:'Direct human review',desc:'Every application is reviewed personally, not filtered by bots'},
];

export default function ApplyScreen({ onBack, onSuccess }) {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    full_name: '',
    email: '',
    phone: '',
    content_type: '',
    social_instagram: '',
    social_tiktok: '',
    social_youtube: '',
    sample_work_url: '',
    why_vaultt: '',
  });

  const update = (field, value) => setForm(f => ({...f, [field]: value}));

  const inp = {
    width:'100%',
    padding:'14px 16px',
    border:'1px solid '+C.border,
    borderRadius:14,
    fontSize:15,
    outline:'none',
    fontFamily:'inherit',
    marginBottom:14,
    boxSizing:'border-box',
    background:'rgba(255,255,255,0.04)',
    color:C.ink,
    boxShadow:'inset 0 1px 0 rgba(255,255,255,0.04)',
  };

  const handleSubmit = async () => {
    if (!form.full_name || !form.email || !form.content_type || !form.why_vaultt) {
      setError('Please fill in all required fields.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const { error: dbError } = await supabase
        .from('creator_applications')
        .insert({
          full_name: form.full_name,
          email: form.email,
          phone: form.phone,
          content_type: form.content_type,
          social_instagram: form.social_instagram,
          social_tiktok: form.social_tiktok,
          social_youtube: form.social_youtube,
          sample_work_url: form.sample_work_url,
          why_vaultt: form.why_vaultt,
          status: 'pending',
        });
      if (dbError) throw dbError;
      setStep(3);
      if (onSuccess) onSuccess();
    } catch(e) {
      setError(e.message || 'Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  const chip = {
    padding:'10px 14px',
    background:'rgba(255,255,255,0.06)',
    border:`1px solid ${C.panelBorder}`,
    borderRadius:999,
    fontSize:12,
    fontWeight:700,
    color:C.inkSoft,
    backdropFilter:'blur(18px)',
  };

  return (
    <div style={{
      minHeight:'100vh',
      background:`radial-gradient(circle at 18% 18%, rgba(50, 116, 214, 0.28), transparent 34%), radial-gradient(circle at 78% 14%, rgba(244, 208, 137, 0.12), transparent 26%), linear-gradient(180deg, ${C.bg} 0%, #040812 100%)`,
      display:'flex',
      color:C.ink,
    }}>
      {/* Left panel */}
      <div style={{
        flex:1,
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        padding:'56px 48px',
        position:'sticky',
        top:0,
        height:'100vh',
        background:'linear-gradient(180deg, rgba(11, 20, 34, 0.24) 0%, rgba(7, 13, 24, 0.08) 100%)',
      }}>
        <div style={{
          width:'100%',
          maxWidth:430,
          padding:'42px 38px',
          borderRadius:34,
          background:'linear-gradient(180deg, rgba(13, 22, 37, 0.84) 0%, rgba(10, 17, 29, 0.9) 100%)',
          border:'1px solid rgba(148, 163, 184, 0.14)',
          boxShadow:'0 36px 90px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.04)',
          backdropFilter:'blur(24px)',
        }}>
        <div style={{fontFamily:'Arial',fontSize:48,fontWeight:900,letterSpacing:8,color:'#fff',marginBottom:10,textAlign:'center'}}>VAULTT</div>
        <div style={{fontSize:19,color:'rgba(255,255,255,0.76)',marginBottom:22,fontStyle:'italic',textAlign:'center'}}>Stream. Create. Earn.</div>
        <div style={{display:'inline-flex',alignItems:'center',gap:8,background:'rgba(255,255,255,0.08)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:999,padding:'9px 16px',fontSize:11,fontWeight:800,color:'#fff',letterSpacing:1.8,textTransform:'uppercase',marginBottom:34,marginLeft:'auto',marginRight:'auto'}}>
          <span style={{width:6,height:6,borderRadius:'50%',background:C.gold,display:'inline-block'}}/>
          Pre-launch creator applications
        </div>
        <div style={{width:'100%'}}>
          <div style={{fontSize:13,fontWeight:800,color:C.gold,letterSpacing:2.2,textTransform:'uppercase',marginBottom:12}}>Why Apply Now</div>
          <div style={{fontSize:34,lineHeight:1.08,fontWeight:900,color:'#fff',marginBottom:14}}>Build your channel before the public arrives.</div>
          <div style={{fontSize:15,color:'rgba(255,255,255,0.72)',lineHeight:1.75,marginBottom:24}}>VAULTT is still in pre-launch. Founding creators are being selected now so channels can be ready before the platform opens publicly.</div>
          {BENEFITS.map((b,i) => (
            <div key={i} style={{display:'flex',gap:14,alignItems:'flex-start',padding:'14px 0',borderBottom:'1px solid rgba(255,255,255,0.09)'}}>
              <div style={{fontSize:20,flexShrink:0,width:34,height:34,borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.08)'}}>{b.icon}</div>
              <div>
                <div style={{fontSize:14,fontWeight:800,color:'#fff',marginBottom:4}}>{b.label}</div>
                <div style={{fontSize:12,color:'rgba(255,255,255,0.64)',lineHeight:1.55}}>{b.desc}</div>
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>

      {/* Right panel */}
      <div style={{width:560,overflowY:'auto',padding:48,background:'rgba(255,255,255,0.02)'}}>
        <div style={{
          width:'100%',
          maxWidth:540,
          margin:'0 auto',
          padding:'42px 38px',
          borderRadius:34,
          background:'linear-gradient(180deg, rgba(9, 17, 29, 0.94) 0%, rgba(10, 19, 33, 0.9) 100%)',
          border:'1px solid rgba(148, 163, 184, 0.12)',
          boxShadow:'0 36px 90px rgba(0,0,0,0.36), inset 0 1px 0 rgba(255,255,255,0.03)',
          backdropFilter:'blur(24px)',
        }}>
        <button onClick={onBack} style={{background:'none',border:'none',color:C.blue,cursor:'pointer',fontSize:13,fontWeight:700,fontFamily:'inherit',padding:0,marginBottom:28}}>← Back</button>

        {step===1 && (
          <div>
            <div style={{fontFamily:'Arial',fontSize:34,fontWeight:900,color:C.ink,marginBottom:8,lineHeight:1.08}}>Apply as a Founding Creator</div>
            <div style={{fontSize:14,color:C.copy,marginBottom:20,lineHeight:1.75}}>VAULTT is a curated pre-launch platform. We review every creator application personally to decide who should be part of the founding launch lineup.</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',marginBottom:28}}>
              {['Personal review','Free to apply','Response in 3 business days'].map((item, i) => (
                <span key={i} style={chip}>{item}</span>
              ))}
            </div>

            {error && <div style={{background:'rgba(127, 29, 29, 0.24)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:14,padding:'12px 16px',fontSize:13,color:'#fecaca',marginBottom:16}}>{error}</div>}

            <div style={{fontSize:14,fontWeight:800,color:C.ink,marginBottom:12,letterSpacing:0.2}}>Personal Details</div>
            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>Full Name *</label>
            <input style={inp} placeholder="Your full name" value={form.full_name} onChange={e=>update('full_name',e.target.value)}/>
            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>Email Address *</label>
            <input style={inp} type="email" placeholder="your@email.com" value={form.email} onChange={e=>update('email',e.target.value)}/>
            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>Phone Number</label>
            <input style={inp} type="tel" placeholder="082 000 0000" value={form.phone} onChange={e=>update('phone',e.target.value)}/>

            <div style={{fontSize:14,fontWeight:800,color:C.ink,marginBottom:12,marginTop:8}}>Content Type *</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:20}}>
              {CONTENT_TYPES.map(ct => (
                <div key={ct.id} onClick={()=>update('content_type',ct.id)}
                  style={{
                    border:'1px solid '+(form.content_type===ct.id?C.blueB:C.border),
                    borderRadius:18,
                    padding:18,
                    cursor:'pointer',
                    background:form.content_type===ct.id?'linear-gradient(180deg, rgba(90, 162, 255, 0.12) 0%, rgba(90, 162, 255, 0.08) 100%)':'rgba(255,255,255,0.03)',
                    transition:'all 0.18s',
                    boxShadow:form.content_type===ct.id?'inset 0 1px 0 rgba(255,255,255,0.04), 0 12px 28px rgba(11, 120, 255, 0.08)':'none'
                  }}>
                  <div style={{fontSize:24,marginBottom:8}}>{ct.icon}</div>
                  <div style={{fontSize:15,fontWeight:800,color:form.content_type===ct.id?C.ink:C.ink,marginBottom:6}}>{ct.label}</div>
                  <div style={{fontSize:12,color:C.copy,lineHeight:1.5}}>{ct.desc}</div>
                </div>
              ))}
            </div>

            <button onClick={()=>{
              if(!form.full_name||!form.email||!form.content_type){setError('Please fill in your name, email and content type.');return;}
              setError('');setStep(2);
            }} style={{width:'100%',padding:'16px 18px',background:'linear-gradient(135deg, #65a8ff 0%, #2f8aff 100%)',color:'#fff',border:'none',borderRadius:16,fontSize:15,fontWeight:800,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 20px 38px rgba(47, 138, 255, 0.26)'}}>
              Continue →
            </button>
          </div>
        )}

        {step===2 && (
          <div>
            <div style={{fontFamily:'Arial',fontSize:34,fontWeight:900,color:C.ink,marginBottom:8}}>Tell us more</div>
            <div style={{fontSize:14,color:C.copy,marginBottom:32,lineHeight:1.75}}>Share your existing work, your audience and why VAULTT should consider you for the founding creator group.</div>

            {error && <div style={{background:'rgba(127, 29, 29, 0.24)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:14,padding:'12px 16px',fontSize:13,color:'#fecaca',marginBottom:16}}>{error}</div>}

            <div style={{fontSize:14,fontWeight:800,color:C.ink,marginBottom:12}}>Social Media Presence</div>
            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>Instagram</label>
            <div style={{display:'flex',marginBottom:14}}>
              <div style={{padding:'14px 14px',background:'rgba(255,255,255,0.04)',border:'1px solid '+C.border,borderRight:'none',borderRadius:'14px 0 0 14px',fontSize:13,color:C.grey,flexShrink:0}}>instagram.com/</div>
              <input style={{...inp,marginBottom:0,borderRadius:'0 14px 14px 0',borderLeft:'none'}} placeholder="yourhandle" value={form.social_instagram} onChange={e=>update('social_instagram',e.target.value)}/>
            </div>
            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>TikTok</label>
            <div style={{display:'flex',marginBottom:14}}>
              <div style={{padding:'14px 14px',background:'rgba(255,255,255,0.04)',border:'1px solid '+C.border,borderRight:'none',borderRadius:'14px 0 0 14px',fontSize:13,color:C.grey,flexShrink:0}}>tiktok.com/@</div>
              <input style={{...inp,marginBottom:0,borderRadius:'0 14px 14px 0',borderLeft:'none'}} placeholder="yourhandle" value={form.social_tiktok} onChange={e=>update('social_tiktok',e.target.value)}/>
            </div>
            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>YouTube</label>
            <div style={{display:'flex',marginBottom:20}}>
              <div style={{padding:'14px 14px',background:'rgba(255,255,255,0.04)',border:'1px solid '+C.border,borderRight:'none',borderRadius:'14px 0 0 14px',fontSize:13,color:C.grey,flexShrink:0}}>youtube.com/@</div>
              <input style={{...inp,marginBottom:0,borderRadius:'0 14px 14px 0',borderLeft:'none'}} placeholder="yourchannel" value={form.social_youtube} onChange={e=>update('social_youtube',e.target.value)}/>
            </div>

            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>Sample Work URL</label>
            <input style={inp} placeholder="Link to your best video or content (YouTube, Drive, etc.)" value={form.sample_work_url} onChange={e=>update('sample_work_url',e.target.value)}/>

            <label style={{display:'block',fontSize:12,fontWeight:700,color:C.med,marginBottom:6}}>Why do you want to be on VAULTT? *</label>
            <textarea style={{...inp,minHeight:120,resize:'vertical',lineHeight:1.6}}
              placeholder="Tell us about your content vision, your audience, and why VAULTT is the right home for your work..."
              value={form.why_vaultt}
              onChange={e=>update('why_vaultt',e.target.value)}
              maxLength={1000}
            />
            <div style={{fontSize:11,color:C.grey2,marginBottom:20,textAlign:'right'}}>{form.why_vaultt.length}/1000</div>

            <div style={{background:'linear-gradient(180deg, rgba(90, 162, 255, 0.12) 0%, rgba(90, 162, 255, 0.08) 100%)',border:'1px solid '+C.blueB,borderRadius:18,padding:'16px 18px',marginBottom:24,display:'flex',gap:12}}>
              <div style={{fontSize:18,flexShrink:0}}>⏱️</div>
              <div style={{fontSize:12,color:C.med,lineHeight:1.7}}>We review every application personally and respond within 3 business days. Approved creators will be onboarded before launch, not sent live immediately.</div>
            </div>

            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setStep(1)} style={{padding:'14px 24px',border:'1px solid '+C.border,borderRadius:14,background:'rgba(255,255,255,0.03)',color:C.inkSoft,cursor:'pointer',fontFamily:'inherit',fontSize:13,fontWeight:700}}>← Back</button>
              <button onClick={handleSubmit} disabled={loading} style={{flex:1,padding:'16px 18px',background:loading?C.grey:'linear-gradient(135deg, #65a8ff 0%, #2f8aff 100%)',color:'#fff',border:'none',borderRadius:16,fontSize:15,fontWeight:800,cursor:loading?'not-allowed':'pointer',fontFamily:'inherit',boxShadow:loading?'none':'0 20px 38px rgba(47, 138, 255, 0.26)'}}>
                {loading ? 'Submitting...' : 'Submit Application →'}
              </button>
            </div>
          </div>
        )}

        {step===3 && (
          <div style={{textAlign:'center',paddingTop:48}}>
            <div style={{width:80,height:80,borderRadius:'50%',background:'rgba(34,197,94,0.18)',border:'2px solid rgba(34,197,94,0.36)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:36,margin:'0 auto 24px',color:'#dcfce7'}}>✓</div>
            <div style={{fontFamily:'Arial',fontSize:30,fontWeight:900,color:C.ink,marginBottom:8}}>Application Submitted</div>
            <div style={{fontSize:14,color:C.copy,marginBottom:32,lineHeight:1.75,maxWidth:380,margin:'0 auto 32px'}}>
              Thank you {form.full_name.split(' ')[0]}. We have received your application and will review it personally. Expect an update within 3 business days at {form.email}.
            </div>
            <div style={{background:'linear-gradient(180deg, rgba(90, 162, 255, 0.12) 0%, rgba(90, 162, 255, 0.08) 100%)',border:'1px solid '+C.blueB,borderRadius:22,padding:24,marginBottom:32,textAlign:'left'}}>
              <div style={{fontSize:13,fontWeight:800,color:C.gold,letterSpacing:1.2,textTransform:'uppercase',marginBottom:12}}>What happens next</div>
              {[
                'Our team reviews your application and sample work',
                'If approved, we email you with onboarding details and next steps',
                'You set up your channel and prepare your first 3 videos before launch',
                'Your content joins the founding lineup when VAULTT opens publicly',
              ].map((s,i) => (
                <div key={i} style={{display:'flex',gap:10,marginBottom:8}}>
                  <div style={{width:22,height:22,borderRadius:'50%',background:'linear-gradient(135deg, #65a8ff 0%, #2f8aff 100%)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:800,flexShrink:0}}>{i+1}</div>
                  <div style={{fontSize:13,color:C.med,lineHeight:1.55}}>{s}</div>
                </div>
              ))}
            </div>
            <button onClick={onBack} style={{padding:'14px 28px',background:'linear-gradient(135deg, #65a8ff 0%, #2f8aff 100%)',color:'#fff',border:'none',borderRadius:16,fontSize:14,fontWeight:800,cursor:'pointer',fontFamily:'inherit',boxShadow:'0 20px 38px rgba(47, 138, 255, 0.26)'}}>Back to VAULTT</button>
          </div>
        )}
      </div>
      </div>
    </div>
  );
}
